import React from "react";
import ImgBackground from "../components/pngBackground/imageBackground";
import BackgroundImg from "../assets/images/servicesImg.png";
import GetInTouch from "../components/getInTouchComponent/getInTouchComponent";
import "./styles.scss";
import TestimonialsTravala from "../components/testimonialsTravala/testimonialTravala";
import ServiceIcon from "../components/services/serviceIcons";
import { ReactComponent as CodeIcon } from "../assets/icons/codeIcon.svg";
import { ReactComponent as ConsultingIcon } from "../assets/icons/consultingIcon.svg";
import { ReactComponent as CorporateMngIcon } from "../assets/icons/corporateMngIcon.svg";
import { ReactComponent as TechDevIcon } from "../assets/icons/techDevIcon.svg";

const ServicesPage = () => {
  return (
    <div className="main-layout-container ">
      <ImgBackground insideText={"Services"} imgPath={BackgroundImg} />

      <div className="services-content-list">
        <ServiceIcon
          title={"Software Development"}
          content={
            "We provide expert custom software development, technology solutions, corporate management, and consulting services for small and medium-sized businesses, driving innovation and optimizing processes"
          }
          icon={CodeIcon}
          path={'/software-development'}
        />

        <ServiceIcon
          title={"Technology Development"}
          content={
            "Our team leverages the latest technologies to develop scalable, future-proof solutions that support business growth. By focusing on innovation and adaptability, we ensure that your systems are equipped to handle evolving market demands and drive long-term success"
          }
          icon={TechDevIcon}
          path={'/tehnology-management'}
        />

        <ServiceIcon
          title={"Corporate Management"}
          content={
            "We provide strategic corporate management services designed to streamline operations, enhance organizational efficiency, and drive sustained growth, ultimately increasing the overall value of your company."
          }
          icon={CorporateMngIcon}
          path={'/corporate-management'}
        />

        <ServiceIcon
          title={"Consulting"}
          content={
            "Our expert consulting services guide businesses through critical decisions, helping them remain competitive in a dynamic marketplace, while offering tailored guidance and solutions across multiple platforms"
          }
          icon={ConsultingIcon}
          path={'/consulting'}
        />
      </div>

      <GetInTouch />
      {/* <TestimonialsTravala /> */}
    </div>
  );
};

export default ServicesPage;
